import Vue from 'vue'

export const PartnerApi = {
  async fetch() {
    try {
      const response = await Vue.axios.get('/api/v2/partner');

      if(response.status == 200 || response.status == 304) {
        return response.data.preference;
      } else {
        return {}
      }
    } catch (e) {
      console.log(e)
    }
  }
};